import {
  Attribute, AttributeValue,
  NewFilterOption,
  NewFilterOptions
} from './typing/product-types.js'

const updateOption = (option: NewFilterOption, displayMode: string): AttributeValue => {
  let picture = option.picture
  if (displayMode === 'product_image') {
    if (option.product === undefined) {
      console.error('Product image can\'t be retrieved, is VARIANT_FILTER_PRODUCT_DATA turned on in the shop config?')
    }

    picture = option.product?.picture.mini || ''
  }

  return {
    id: option.id,
    count: option.count,
    name: option.name,
    description: option.description,
    css_color: option.css_color,
    picture: picture,
    selected: false,
    orderable: option.orderable ?? true,
  }
}

export class VariantFilterParser {

  mergeFilterOptions = (original: Attribute[], newOptions: NewFilterOptions): Attribute[] => {
    return original.map(attribute => {
      if (attribute.id !== newOptions.attr) {
        return attribute
      }

      const options: AttributeValue[] = newOptions.value?.things.map(
        (option: NewFilterOption): AttributeValue => {
          return updateOption(option, attribute.display_mode ?? '')
        }
      ) || attribute.options

      return {
        ...attribute,
        options,
      }
    })
  }
}
